import { render, staticRenderFns } from "./CustomComponent.form-builder.vue?vue&type=template&id=8bbc7176&"
import script from "./CustomComponent.form-builder.vue?vue&type=script&lang=js&"
export * from "./CustomComponent.form-builder.vue?vue&type=script&lang=js&"
import style0 from "./CustomComponent.form-builder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports